import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

export const noStandardsCss: CSSObject = {
  padding: "12px 32px",

  ...typographyStyles.fontFamily.circular,
};
